import getProductIdForGTM from './getProductIdForGTM';
import getCategoriesFromProduct from './getCategoriesFromProduct';
import getProductVariantIdForGTM from './getProductVariantIdForGTM';

export default () => {
  if (!window.dataLayer?.push || typeof window.dataLayer?.push !== 'function') return 'fail';
  
  const {start} = window;
  const {order} = start;
  
  const getHomeDeliverySetUpStatus = (isHomeDeliverySetUp) => {
    if (isHomeDeliverySetUp == null) return '';
    return isHomeDeliverySetUp;
  };
  const getHomeDeliveryStockStatus = (homeDeliveryStockStatus) => {
    if (homeDeliveryStockStatus == null) return '';
    return homeDeliveryStockStatus ? 'in' : 'out';
  };
  
  try {
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            action: 'checkout',
            step: 2,
            coupon: order.discountCode || '',
          },
          products: order.basketItems.map(basketItem => ({
            id: getProductIdForGTM(basketItem),
            // eslint-disable-next-line max-len
            masterId: basketItem.masterProductId === 0 || !basketItem.masterProductId ? '' : basketItem.masterProductId,
            name: basketItem.productTitle,
            brand: basketItem.brand || '',
            category: basketItem.category || '',
            quantity: basketItem.quantity,
            price: basketItem.chargePricePerUnit.value,
            pricePreDiscount: basketItem.itemPrice.value,
            linePrice: basketItem.totalChargePrice.value,
            currency: basketItem.itemPrice.currencyCode,
            dimension3: basketItem.fulfilmentMethod || '',
            dimension45: basketItem.storeCollectionTypeAvailable || '',
            dimension46: getHomeDeliverySetUpStatus(basketItem.isHomeDeliverySetUp),
            dimension48: getHomeDeliveryStockStatus(basketItem.homeDeliveryStockStatus),
            reviewsGroupingId: basketItem.reviewsGroupingId || '',
          })),
        },
      },
    });
    if (start.settings?.ga4_data_layer_enabled === true) {
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: start.orderTotal.currencyCode,
          value: start.orderTotal.value,
          coupon: order.discountCode || '',
          items: order.basketItems.map(basketItem => ({
            item_id: getProductIdForGTM(basketItem),
            item_name: basketItem.productTitle,
            index: '',
            item_brand: basketItem.brand || '',
            ...getCategoriesFromProduct(basketItem),
            item_list_id: '',
            item_list_name: '',
            item_variant: getProductVariantIdForGTM(basketItem),
            price: basketItem.chargePricePerUnit.value,
            quantity: basketItem.quantity,
          })),
        },
      });
    }
    
    try {
      // adding referrer
      if (window.dataLayer?.length > 0 && window.dataLayer.find(dataEvent => dataEvent.pageCategory)) {
        const pageAttributesObject = window.dataLayer?.find(dataEvent => dataEvent.pageCategory);
        if (pageAttributesObject) {
          window.dataLayer[0] = {
            ...pageAttributesObject,
            pageAttributes: [{
              ...pageAttributesObject.pageAttributes[0],
              referrer: document.referrer,
            }],
          };
        }
      }
    } catch (e) {
      // do nothing
    }
  } catch {
    return 'fail';
  }
  
  return 'success';
};
